export default {
  isDirty: false,
  fiches_pending: false,
  fiches_refresh_pending: false,
  fiches: [],
  lastModified: null
}
